import {APIv1} from "../../api";

export async function deleteSavedMarket({marketId, token}) {
    const finalToken = token || JSON.parse(localStorage.getItem('user'))?.token;

    const body = {
        market_id: marketId,
    };

    try {
        const response = await APIv1.delete('/save/market/delete/', {
            headers: {
                Authorization: `Token ${finalToken}`,
                'Content-Type': 'application/json',
            },
            data: body,
        });

        return response.status === 200 || response.status === 201;
    } catch (error) {
        console.error("Error in deleteSavedMarket:", error);
        return {success: false, message: "Unknown error"};
    }
}
